import request from "../helpers/request";

export const createRestfulApi = (resourceURL) => {
  return {
    getList({ size = 10, page = 1, ...params } = { size: 10, page: 1 }) {
      return request(resourceURL, "POST", {
        page,
        size,
        ...params,
      });
    },
    getItem({ id }) {
      return request(`${resourceURL}/${id}`, "GET");
    },
    deleteItem({ id }) {
      return request(`${resourceURL}/${id}`, "DELETE");
    },
    createItem(data) {
      return request(resourceURL, "POST", data);
    },
    updateService(data) {
      return request(resourceURL, "POST", data);
    },
    updateItem(data) {
      return request(`${resourceURL}/${data.id}`, "PUT", data);
    },
  };
};
